import React from 'react';

import asyncComponent from './../../../hoc/async-component/async-component';

const AsyncIntro = asyncComponent(() => import ('./../../platform_intro'));
const AsyncVideoTutoring = asyncComponent(() => import ('./../../video-tutoring'));
const MathTutor = asyncComponent(() => import ('./../../math_quiz'));
const MathCurrentQuizInfo = asyncComponent(() => import ('./../../math_quiz/inner_pages/info'));
const MathCurrentQuiz = asyncComponent(() => import ('./../../math_quiz/inner_pages/exercise'));
const AsyncVideoTheory = asyncComponent(() => import ('./../../video-tutoring/inner_pages/theory'));
const AsyncVideoPractice = asyncComponent(() => import ('./../../video-tutoring/inner_pages/practice'));
const AsyncVideoTask = asyncComponent(() => import ('../../video-tutoring/inner_pages/exercise'));
const AsyncOnlineContestInfo = asyncComponent(() => import ('./../../online_contest/inner_pages/info'));
const AsyncOnlineContestExercise = asyncComponent(() => import ('./../../online_contest/inner_pages/exercise'));

export const internalRoutesArray = [
  {
    'path': '/intro',
    'mainComponent': (props) => <AsyncIntro {...props} />
  },
  {
    'exact': true,
    'path': '/video-tutor',
    'mainComponent': (props) => <AsyncVideoTutoring {...props} />
  },
  {
    'path': '/video-tutor/theory/:free/:id',
    'mainComponent': (props) => <AsyncVideoTheory {...props} />
  },
  {
    'path': '/video-tutor/practice/:free/:id',
    'mainComponent': (props) => <AsyncVideoPractice {...props} />
  },
  {
    'path': '/video-tutor/exercise/:free/:id/:pageNum',
    'mainComponent': (props) => <AsyncVideoTask {...props} />
  },
  {
    'exact': true,
    'path': '/math-tutor',
    'mainComponent': (props) => <MathTutor {...props} />
  },
  {
    'path': '/math-tutor/info/:id',
    'mainComponent': (props) => <MathCurrentQuizInfo {...props} />
  },
  {
    'path': '/math-tutor/exercise/:free/:id/:pageNum/:status',
    'mainComponent': (props) => <MathCurrentQuiz {...props} />
  },
  {
    'path': '/contest/info/:id',
    'mainComponent': (props) => <AsyncOnlineContestInfo {...props} />
  },
  {
    'path': '/contest/exercise/:free/:id/:pageNum/:status',
    'mainComponent': (props) => <AsyncOnlineContestExercise {...props} />
  }
]